import CompanyFulfillmentsOmsIndex from "@/components/oms/company_fulfillments/CompanyFulfillmentsOmsIndex.vue";
import CompanyFulfillmentsOmsAdd from "@/components/oms/company_fulfillments/CompanyFulfillmentsOmsAdd.vue";
import CompanyFulfillmentsOmsDetail from "@/components/oms/company_fulfillments/CompanyFulfillmentsOmsDetail.vue";
import CompanyFulfillmentsOmsEdit from "@/components/oms/company_fulfillments/CompanyFulfillmentsOmsEdit.vue";

let routesCompanyFulfillmentsOmsAccess= [
    {
        path: '',
        meta: {
          title: "List Company Fulfillments Access",
        },
        name: "CompanyFulfillmentsOmsIndex",
        component: CompanyFulfillmentsOmsIndex
    },
    {
        path: 'create',
        meta: {
          title: "Create Company Fulfillments Access",
        },
        name: "CompanyFulfillmentsOmsAdd",
        component: CompanyFulfillmentsOmsAdd
    },
     
    {
        path: 'detail/:id',
        meta: {
          title: "Detail Company Fulfillments Access",
        },
        name: "CompanyFulfillmentsOmsDetail",
        component: CompanyFulfillmentsOmsDetail
    },
     
    {
        path: 'edit/:id',
        meta: {
          title: "Edit Company Fulfillments Access",
        },
        name: "CompanyFulfillmentsOmsEdit",
        component: CompanyFulfillmentsOmsEdit
    },
    
    
]

export default routesCompanyFulfillmentsOmsAccess
  